const sliceToLastWord = (
    maxLength: number,
    original?: string,
): [boolean, string] => {
    if (!original) {
        return [false, ''];
    }

    const slicedByCharacter = original.slice(0, maxLength);

    // Verify using trimByCharacter, because trimByLastWord will always remove the last word.
    const isSliced = slicedByCharacter !== original;

    // Find last complete word
    const indexOfLastSpace = slicedByCharacter.lastIndexOf(' ');
    const slicedByLastWord = slicedByCharacter.slice(0, indexOfLastSpace);

    const text = isSliced ? slicedByLastWord : original;

    return [isSliced, text];
};

export default sliceToLastWord;
